import ModelFactory from "../Definition/ModelFactory";
const CatalogMemberFactory = new ModelFactory();
export default CatalogMemberFactory;